import React, { useState, useEffect } from 'react';
import {
    Box,
    Button,
    Card,
    CardContent,
    Typography,
    CircularProgress,
    Alert,
    Grid,
    Paper,
    LinearProgress,
    TextField
} from '@mui/material';
import { Sync as SyncIcon } from '@mui/icons-material';
import BackendConnector from '../middleware/BackendConnector';
import { useUser } from '../context/UserContext'
import { Navigate } from 'react-router-dom';

const LDAPSync = () => {
    const [syncing, setSyncing] = useState(false);
    const [status, setStatus] = useState(null);
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);
    const [password, setPassword] = useState('');
    const userContext = useUser();


    const fetchStatus = async () => {
        try {
            const response = await BackendConnector.ldapstatus();
            setStatus(response.data || response);
        } catch (err) {
            console.error('Failed to fetch sync status:', err);
        }
    };

    useEffect(() => {
        fetchStatus();
        const interval = setInterval(fetchStatus, 300000);
        return () => clearInterval(interval);
    }, []);

    if (!userContext.isAdmin()) return <Navigate to="/" replace />;

    const handleSync = async () => {
        setSyncing(true);
        setError(null);
        setResult(null);

        try {
            const response = await BackendConnector.ldapsync(password);
            console.log(response)
            if (!response.success) {
                setError(response.message);
                return;
            }
            setResult(response.data);
            setTimeout(() => {
                setResult(null);
            }, 5000);
        } catch (err) {
            console.log(err)
            setError(err.response?.message || 'Синхронизация не удалась');
        } finally {
            setSyncing(false);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'никогда';
        return new Date(dateString).toLocaleString();
    };

    return (
        <Box sx={{ maxWidth: 800, margin: '0 auto', p: 3 }}>
            <Typography variant="h4" gutterBottom>
                LDAP синхронизация
            </Typography>

            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                Статус синхронизации
                            </Typography>
                            {status ? (
                                <Box>
                                    <Typography>
                                        <strong>Последняя синхронизация:</strong> {formatDate(status.updateAt)}
                                    </Typography>
                                    <Typography>
                                        <strong>Активные пользователя:</strong> {status.stats?.active || 0}
                                    </Typography>
                                    <Typography>
                                        <strong>Деактивированные пользователя:</strong> {status.stats?.inactive || 0}
                                    </Typography>
                                </Box>
                            ) : (
                                <CircularProgress size={24} />
                            )}
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                Ручная синхронизация
                            </Typography>

                            <TextField
                                fullWidth
                                type="password"
                                label="LDAP пароль"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                margin="normal"
                            />

                            <Button
                                variant="contained"
                                startIcon={syncing ? <CircularProgress size={20} /> : <SyncIcon />}
                                onClick={handleSync}
                                disabled={syncing}
                                fullWidth
                                sx={{ mt: 2 }}
                            >
                                {syncing ? 'Синхронизация...' : 'Начать'}
                            </Button>

                            <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                                Введите LDAP пароль и нажмите "Начать"
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>

                {result && (
                    <Grid item xs={12}>
                        <Alert severity="success" onClose={() => setResult(null)}>
                            <Typography variant="h6">Синхронизация завершена</Typography>
                            <Typography>
                                Синхронизировано: {result?.synced || 0} пользователей
                                {result?.errors?.length > 0 &&
                                    ` (${result.errors.length} ошибок)`}
                            </Typography>
                        </Alert>
                    </Grid>
                )}

                {error && (
                    <Grid item xs={12}>
                        <Alert severity="error" onClose={() => setError(null)}>
                            {error}
                        </Alert>
                    </Grid>
                )}

                {syncing && (
                    <Grid item xs={12}>
                        <Paper sx={{ p: 2 }}>
                            <Typography>Синхронизация...</Typography>
                            <LinearProgress />
                        </Paper>
                    </Grid>
                )}
            </Grid>
        </Box>
    );
};

export default LDAPSync;
